import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ManagementTypesEnum } from './rest-api/rest-api';
import { UserService } from './user/user.service';
import { RestApiService } from './rest-api/rest-api.service';
import { shareReplay, map, catchError } from 'rxjs/operators';
import { ExpectedOwnedStrategy } from '../shared/owned-strategy-card/strategy';

@Injectable({
  providedIn: 'root'
})
export class ExecutionOnlyGuardService  {

  public constructor(
    private userService: UserService,
    private router: Router,
    private restApiService: RestApiService,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const partialAccess = !!route.data?.['partialAccess'];

    if (this.userService.loggedUser!.managementType === ManagementTypesEnum.EXECUTION_ONLY) {
      return true;
    }

    // Users who had access to strategies (creating/editing/deleting) but have lost it when they filled in new questionnaire
    // these users should still be able to edit/delete their already created strategies
    if (partialAccess) {
      return this.restApiService.getPortfoliosAndStrategies()
      .pipe(
        map((data: ExpectedOwnedStrategy[]) => data.some(i => i.portfolioType === 'STRATEGY')),
        catchError(() => {
          this.router.navigate(['/summary']);
          return of(false);
        }),
        shareReplay()
      )
    } else {
      this.router.navigate(['/summary']);
      return false;
    }
  }
}
